import React, {Component} from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import Slider from "react-slick"
import Fade from 'react-reveal/Fade'

class Agent3Columns extends Component {

  render() {

    const { items } = this.props

    let settings = {
      autoplay: true,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
    }

    return (
      <section className='advocacy-block'>
        <div className="advocacy-block__inner container">
          <div className='advocacy-block__items advocacy-block__items--mobile'>
            <Slider ref={slider => (this.slider = slider)} {...settings}>
              { items?.map((el, i) => (
                <div className='advocacy-block__item' key={i}>
                  { el.image && <GatsbyImage image={getImage(el.image.localFile)} alt={el.title} /> }
                  <h4>{el.title}</h4>
                  <div className='advocacy-block__item-content' dangerouslySetInnerHTML={{ __html: el.content }} />
                </div>
              )) }
            </Slider>
          </div>
          <Fade bottom distance='40px'>
            <div className='advocacy-block__items advocacy-block__items--desktop'>
              { items?.map((el, i) => (
                <div className='advocacy-block__item' key={i}>
                  { el.image && <GatsbyImage image={getImage(el.image.localFile)} alt={el.title} /> }
                  <h4>{el.title}</h4>
                  <div className='advocacy-block__item-content' dangerouslySetInnerHTML={{ __html: el.content }} />
                </div>
              )) }
            </div>
          </Fade>
        </div>
      </section>
    )
  }
}

export default Agent3Columns
